/**
 * Notable Clients Section for Assistant Profile
 * Allows adding and removing notable clients/venues
 */
import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus, X } from "lucide-react";

export default function NotableClientsSection({ notableClients, setNotableClients }) {
  const [newClient, setNewClient] = useState("");

  const addClient = () => {
    if (newClient.trim() && !notableClients.includes(newClient.trim())) {
      setNotableClients([...notableClients, newClient.trim()]);
      setNewClient("");
    }
  };

  const removeClient = (client) => {
    setNotableClients(notableClients.filter(c => c !== client));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addClient();
    }
  };

  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-6">Notable Clients or Venues</h2>
      <div className="flex gap-2 mb-4">
        <Input
          value={newClient}
          onChange={(e) => setNewClient(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="e.g., The Ritz Carlton, Four Seasons..."
          className="bg-white/[0.05] border-white/10 focus:border-white/40 text-white h-12 rounded-sm"
          data-testid="notable-client-input"
        />
        <Button 
          type="button" 
          onClick={addClient} 
          className="bg-white/10 hover:bg-white/20 text-white h-12 px-4 rounded-sm"
          data-testid="add-client-button"
        >
          <Plus className="w-5 h-5" />
        </Button>
      </div>
      {notableClients.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {notableClients.map((client) => (
            <span 
              key={client} 
              className="inline-flex items-center gap-1 bg-white/10 text-white px-3 py-1 rounded-sm text-sm"
            >
              {client}
              <button 
                type="button" 
                onClick={() => removeClient(client)} 
                className="hover:text-red-400"
                data-testid={`remove-client-${client}`}
              >
                <X className="w-3 h-3" />
              </button>
            </span>
          ))}
        </div>
      )}
    </Card>
  );
}
